import React, { useState, useEffect } from 'react';
import CopyValue from './CopyValue';

/**
 * Shorten a given string down to 8 characters, adding an ellipsis
 * in the middle if the string is longer than 8 characters.
 *
 * Also adds a copy-to-clipboard button if the `allowCopy` property is
 * not set to false.
 *
 * @param {Object} props
 * @param {string} props.sid - The string to shorten
 * @param {boolean} [props.allowCopy=true] - Whether to add a copy button
 *
 * @returns {React.ReactElement}
 */
const ShortenSid = (props) => {
  const [allowCopy, setAllowCopy] = useState(
    !props.hasOwnProperty('allowCopy') ? true : props.allowCopy
  );

  const formatString = (str) => {
    if (str) {
      if (str.length <= 8) {
        return str;
      }
      return `${str.slice(0, 4)} ... ${str.slice(-4)}`;
    } else {
      return '';
    }
  };

  const formattedString = formatString(props.sid);

  return (
    <>
      {formattedString}
      {allowCopy && (
        <CopyValue margin="none none none x-small" text={props.sid} />
      )}
    </>
  );
};

export default ShortenSid;
